import Color from "color";
import { isNullOrUndefined } from "../better/utils";
function getThemeColorRef(color, colorType) {
    return typeof colorType === "undefined"
        ? `--revo-color-${color}`
        : `--revo-color-${color}-${colorType}`;
}
export function getThemeColorVar(color, colorType) {
    return `var(${getThemeColorRef(color, colorType)})`;
}
export function getThemeColor(color, colorType) {
    const cssVariableName = getThemeColorRef(color, colorType);
    const style = getComputedStyle(document.body);
    const maybevalue = style.getPropertyValue(cssVariableName);
    if (isNullOrUndefined(maybevalue) || maybevalue == "")
        throw Error(`Color --revo-color-${color}-${colorType} was not found.`);
    return Color(maybevalue.trim());
}
//# sourceMappingURL=color.js.map